// extracted by mini-css-extract-plugin
module.exports = {"quiz":"Quiz-module__quiz___2UEVU"};